import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { Button } from '../components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Textarea } from '../components/ui/textarea';
import { Phone, Mail, MapPin, Clock, Facebook ,Instagram,Linkedin} from 'lucide-react';

export default function ContactPage() {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />

      {/* Hero Section */}
      <section className="bg-gradient-to-br from-primary to-primary/90 text-primary-foreground py-16">
        <div className="mx-auto max-w-7xl px-6 lg:px-8">
          <div className="max-w-2xl">
            <h1 className="text-4xl font-bold tracking-tight sm:text-5xl mb-4 font-playfair">
              Contact Us
            </h1>
            <p className="text-lg text-primary-foreground/90 leading-relaxed">
              Get in touch with us for appointments, inquiries, or any questions about our services.
            </p>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section className="py-16">
        <div className="mx-auto max-w-5xl px-6 lg:px-10">
          <div className="grid grid-cols-1 lg:grid-cols-1 gap-12">
            {/* Contact Form */}
            <div>
              {/* <Card>
                <CardHeader>
                  <CardTitle className="text-2xl">Send Us a Message</CardTitle>
                  <CardDescription>
                    Fill out the form below and we'll get back to you as soon as possible.
                  </CardDescription>
                </CardHeader>
                <CardContent>
                  <form className="space-y-6">
                    <div className="space-y-2">
                      <Label htmlFor="name">Full Name *</Label>
                      <Input id="name" placeholder="Your name" required />
                    </div>

                    <div className="space-y-2">
                      <Label htmlFor="email">Email *</Label>
                      <Input id="email" type="email" placeholder="your.email@example.com" required />
                    </div>

                    <div className="space-y-2">
                      <Label htmlFor="phone">Phone Number</Label>
                      <Input id="phone" type="tel" placeholder="+91 99999 99999" />
                    </div>

                    <div className="space-y-2">
                      <Label htmlFor="subject">Subject *</Label>
                      <Input id="subject" placeholder="How can we help you?" required />
                    </div>

                    <div className="space-y-2">
                      <Label htmlFor="message">Message *</Label>
                      <Textarea id="message" placeholder="Tell us more about your inquiry..." rows={5} required />
                    </div>

                    <Button type="submit" size="lg" className="w-full sm:w-auto">
                      Send Message
                    </Button>
                  </form>
                </CardContent>
              </Card> */}
            </div>

            {/* Contact Information */}
            <div className="space-y-6">
              <div>
                <h2 className="text-2xl font-bold mb-6 font-playfair">Get in Touch</h2>
                <p className="text-muted-foreground leading-relaxed mb-8">
                  We're here to answer your questions and provide the care you need. Reach out to us through any of the
                  following channels.
                </p>
              </div>

              <Card>
                <CardContent className="pt-6 space-y-6">
                  <div className="flex items-start gap-4">
                    <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-secondary/10  flex-shrink-0">
                      <Phone className="h-5 w-5" />
                    </div>
                    <div>
                      <h3 className="font-semibold mb-1">Phone</h3>
                      <a href="tel:+917995918882" className="text-muted-foreground hover:text-primary">
                        +91 9989345545
                      </a>
                      <p className="text-sm text-muted-foreground mt-1">Mon-Sat: 9:00 AM - 9:00 PM</p>
                    </div>
                  </div>

                  <div className="flex items-start gap-4">
                    <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-secondary/10  flex-shrink-0">
                      <Mail className="h-5 w-5" />
                    </div>
                    <div>
                      <h3 className="font-semibold mb-1">Email</h3>
                      <a href="mailto:osichyd@gmail.com" className="text-muted-foreground hover:text-primary">
                        vrsujitkumar@gmail.com
                      </a>
                      <p className="text-sm text-muted-foreground mt-1">We'll respond within 24 hours</p>
                    </div>
                  </div>

                  <div className="flex items-start gap-4">
                    <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-secondary/10  flex-shrink-0">
                      <MapPin className="h-5 w-5" />
                    </div>
                    <div>
                      <h3 className="font-semibold mb-1">Address</h3>
                      <p className="text-muted-foreground">
                        Flat No. G8, SERENE VIEW Apartment Complex
                        <br />
                        PJR Enclave Main Road
                        <br />
                        Madhavapuri Hills, Chanda Nagar
                        <br />
                        Telangana 502032
                      </p>
                    </div>
                  </div>

                  <div className="flex items-start gap-4">
                    <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-secondary/10  flex-shrink-0">
                      <Clock className="h-5 w-5" />
                    </div>
                    <div>
                      <h3 className="font-semibold mb-1">Clinic Hours</h3>
                      <p className="text-muted-foreground">
                        Monday - Saturday: 5:00 PM - 8:00 PM(By Appointment Only)
                        
                      </p>
                    </div>
                  </div>

                  <div className="flex items-start gap-4">
                    <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-secondary/10  flex-shrink-0">
                      <Facebook className="h-5 w-5" />
                    </div>
                    <div>
                      <h3 className="font-semibold mb-1">Social Media</h3>
                      <li className="flex items-center gap-2">
                <Facebook className="h-4 w-4 flex-shrink-0" />
                <a
                  href="https://www.facebook.com/OrthopedicSportsInjuryClinic"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-muted-foreground"
                >
                  Follow us on Facebook
                </a>
              </li>
              <li className="flex items-center gap-2">
                <Instagram className="h-4 w-4 flex-shrink-0" />
                <a
                  href="https://www.instagram.com/drsujit_sportssurgeon?utm_source=qr&igsh=MXR1MGl6dmx6MGU0ZA=="
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-muted-foreground"
                >
                  Follow us on Instagram
                </a>
              </li>
              <li className="flex items-center gap-2">
                <Linkedin className="h-4 w-4 flex-shrink-0" />
                <a
                  href="https://www.linkedin.com/in/vrsujit-kumar-94bb6619?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-muted-foreground"
                >
                  Connect on LinkedIn
                </a>
              </li>
                    </div>
                  </div>
                </CardContent>
              </Card>

              <Card className="bg-secondary text-secondary-foreground">
                <CardHeader>
                  <CardTitle>Need Immediate Assistance?</CardTitle>
                </CardHeader>
                <CardContent>
                  <p className="text-secondary-foreground/90 mb-4">
                    For urgent medical concerns or emergencies, please call us directly.
                  </p>
                  <Button variant="secondary"  asChild>
                    <a href="tel:+917995918882">
                      <Phone className="mr-2 h-4 w-4" />
                      Call Now: +91 9989345545
                    </a>
                  </Button>
                </CardContent>
              </Card>
            </div>
          </div>
        </div>
      </section>

      {/* Map Section */}
      <section className="py-16 bg-muted/30">
        <div className="mx-auto max-w-7xl px-6 lg:px-8">
          <div className="text-center mb-8">
            <h2 className="text-3xl font-bold mb-4 font-playfair">Find Us</h2>
            <p className="text-muted-foreground">
              Located in Chanda Nagar, Hyderabad - Easy to reach and ample parking available
            </p>
          </div>
          <div className="rounded-lg overflow-hidden shadow-lg h-[400px] bg-muted flex items-center justify-center">
            <div className="text-center">
              <MapPin className="h-12 w-12 text-muted-foreground mx-auto mb-4" />
              <p className="text-muted-foreground">
                Flat No. G8, SERENE VIEW Apartment Complex
                <br />
                PJR Enclave Main Road, Madhavapuri Hills
                <br />
                Chanda Nagar, Telangana 502032
              </p>
              <Button variant="outline" className="mt-4 bg-transparent" asChild>
                <a
                  href="https://www.google.com/maps/search/?api=1&query=Flat+No.+G8+SERENE+VIEW+Apartment+Complex+PJR+Enclave+Main+Road+Madhavapuri+Hills+Chanda+Nagar+Telangana+502032"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Open in Google Maps
                </a>
              </Button>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}